import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {inspectionApi} from './builder/inspections.api';
import inspectionSlice from './builder/inspectionSlice';
import reducer from './builder/reducer';
import loginSlice from './builder/loginSlice';
import equipmentEditSlice from './builder/equipmentEditSlice';
import forgotPasswordSlice from './builder/forgotPasswordSlice';
import registerSlice from './builder/registerSlice';
import paymentSlice from './builder/paymentSlice';
import agenciesListSlice from './builder/agenciesListSlice';
import revisionsSlice from './builder/revisiions/revisionsSlice';
import {revisionsApi} from './builder/revisiions/revisions.api';
import createFormSlice from '../pages/CreateNewForm/service/createForm.slice';

const rootReducer = combineReducers({
  inspectionSlice,
  reducer,
  loginSlice,
  equipmentEditSlice,
  forgotPasswordSlice,
  registerSlice,
  paymentSlice,
  agenciesListSlice,
  createFormSlice,
  revisionsSlice,
});

export const store = configureStore({
  reducer: {
    [inspectionApi.reducerPath]: inspectionApi.reducer,
    [revisionsApi.reducerPath]: revisionsApi.reducer,
    rootReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(inspectionApi.middleware)
      .concat(revisionsApi.middleware),
});
